/**
 * NÉV-KERESÉS KÖZÖS ÖSSZEVETÉSI ALAKJA [Web UX 3. csomag (C), 1. validátor-kör M6, 2026-10-04]
 *
 * MI VOLT A BAJ: ugyanez a szabály KÉT helyen élt, két névvel — `utils/reportSort.ts`
 * `normalizeForSearch` (a kimutatás névkeresője) és `components/EventAttendance.tsx`
 * `normalizeNameForSearch` (a jelenléti ív névszűrője). Egy későbbi módosítás (pl. a „ő"/„ű"
 * kezelése) könnyen csak az egyikbe került volna, és a két képernyő mást talált volna ugyanarra.
 * Mostantól mindkettő EZT használja.
 *
 * A SZABÁLY: kis-nagybetű ÉS ékezet-érzéketlen alak — NFD-felbontás, a kombináló ékezetjelek
 * (U+0300–U+036F) eldobása, magyar kisbetűsítés, szélek levágása. „Ödön" ~ „odon", „ÁCS" ~ „acs",
 * „Csizmár" ~ „csizmar". `null`/`undefined` → üres szöveg.
 */
export function normalizeForSearch(s: string | undefined | null): string {
  return String(s ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLocaleLowerCase('hu')
    .trim();
}
